import {Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {SeparatorComponent} from '@/app/shared/components/separator/separator.component';
import {ButtonComponent} from '@/app/shared/components/buttons/button/button.component';
import {ButtonSmallComponent} from '@/app/shared/components/buttons/button-small/button-small.component';
import {Title} from '@angular/platform-browser';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {LastVideosComponent} from '@components/last-videos/last-videos.component';
import {LegendService} from '@services/legend.service';
import {GalleryService} from '@services/gallery.service';
import {GalleryTiny} from '@/app/core/models/gallery';
import {environment} from '@/environments/environment';
import {TranslateDynamicService} from '@services/translate-dynamic.service';
import {LocalizedDatePipe} from '@/app/shared/pipes/localizedDate.pipe';
import {NgClass, NgStyle} from '@angular/common';
import {EmoteSceneV2Component} from '@components/emote-scene-v2/emote-scene-v2.component';

@Component({
	selector: 'app-club',
	imports: [
		SeparatorComponent,
		ButtonComponent,
		ButtonSmallComponent,
		TranslatePipe,
		LastVideosComponent,
		LocalizedDatePipe,
		NgClass,
		NgStyle,
		EmoteSceneV2Component,
	],
	templateUrl: './club.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./club.component.css'],
})
export class ClubComponent implements OnInit {

	constructor(
		private readonly titleService: Title,
		protected readonly translate: TranslateService,
		private readonly legendService: LegendService,
		private readonly galleryService: GalleryService,
		protected readonly translateDynamicService: TranslateDynamicService
	) {}

	@ViewChild('sliderTrack') sliderTrack!: ElementRef;

	currentIndex: number = 0;
	touchStartX: number = 0;
	touchEndX: number = 0;
	swipeThreshold: number = 20;
	legends: string[] = [];
	galleries: GalleryTiny[] = [];

	minioBaseUrl: string = environment.minioBaseUrl;

	ngOnInit(): void {
		this.loadLegends();
		this.loadGallery();
	}

	loadLegends(): void {
		this.legendService.getLegends().subscribe((legends: string[]) => {
			this.legends = legends.slice().sort((a, b) => a.localeCompare(b));

			const randomLegends = legends
				.sort(() => Math.random() - 0.5)
				.slice(0, 8);
		});
	}

	private getMaxIndex(): number {
		return this.galleries.length > 0 ? this.galleries.length - 1 : 0;
	}

	nextSlide(): void {
		const max = this.getMaxIndex();
		this.currentIndex = this.currentIndex < max
			? this.currentIndex + 1
			: 0;
		this.updateSliderPosition();
	}

	prevSlide(): void {
		const max = this.getMaxIndex();
		this.currentIndex = this.currentIndex > 0
			? this.currentIndex - 1
			: max;
		this.updateSliderPosition();
	}

	private updateSliderPosition() {
		const offset = this.computeOffset();

		if (this.sliderTrack?.nativeElement) {
			this.sliderTrack.nativeElement.style.transform = `translateX(${offset}px)`;
		}
	}

	computeOffset(): number {
		const screenWidth = window.innerWidth;
		let multiplier = 0.2;
/*
		if(screenWidth < 640) {
			multiplier = 0.7;
		}else if (screenWidth < 1024) {
			multiplier = 0.8;
		} else if (screenWidth < 1280) {
			multiplier = 0.7;
		} else if (screenWidth < 1440) {
			multiplier = 0.6;
		} else if (screenWidth >= 1440) {
			multiplier = 0.5;
		} else if (screenWidth < 1920) {
			multiplier = 0.4;
		} else if (screenWidth < 2440) {
			multiplier = 0.3;
		}
*/
		return -this.currentIndex * window.innerWidth * 0.9;
	}

	handleTouchStart(event: TouchEvent) {
		this.touchStartX = event.touches[0].clientX;
	}

	handleTouchEnd(event: TouchEvent) {
		const endX = event.changedTouches?.[0]?.clientX ?? this.touchEndX;
		const distance = endX - this.touchStartX;

		if (distance > this.swipeThreshold) {
			this.prevSlide();
		} else if (distance < -this.swipeThreshold) {
			this.nextSlide();
		}

		this.touchStartX = 0;
		this.touchEndX = 0;
	}

	handleTouchMove(event: TouchEvent) {
		this.touchEndX = event.touches[0].clientX;
	}

	private loadGallery() {
		this.galleryService.getClubGalleries().subscribe((galleries: GalleryTiny[]) => {
			this.galleries = galleries.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
		})
	}

}
